import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import  HomePage from "./components/LandingPage/LandingPage";
import{ServicesPage} from "./components/ServicesPage/ServicesPage";
import {ProjectsPage} from "./components/ProjectsPage/ProjectsPage";
import { ContactPage } from "./components/ContactPage/ContactPage";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import { useEffect } from "react";

 
  
function App() {
  useEffect(() => {
    document.title = "T&T Group";
  }, []);

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
